var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feather-icon',{attrs:{"icon":"Trash2Icon","svgClasses":"h-5 w-5 hover:text-danger cursor-pointer"},on:{"click":_vm.confirmDeleteRecord}})
}
var staticRenderFns = []

export { render, staticRenderFns }